// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"658":"8a238e58","858":"65dfd51d"}[chunkId] + ".chunk.js";
};